import React from 'react';

import { Text } from '../atom/Text';
import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';
import { TextLink } from '../molecules/TextLink';
import { InputForm } from '../organism/InputForm';
import PageTemplate from './PageTemplate';

import { useHistory } from 'react-router-dom';
import * as PATH from '../../../lib/routes/path';
import { NaverLoginButton } from '../molecules/NaverLoginButton';
import { babyface } from '../../../lib/image/CDNUrl';
import styled from 'styled-components';

const SigninTemplate = ({
  state,
  onChangeValue,
  onValidate,
  onSignin,
  isValidateTrue,
  isLoading,
}) => {
  const history = useHistory();

  return (
    <PageTemplate title={PAGE_TITLE}>
      <Text
        style={{ display: 'block' }}
        weight='bold'
        textAlign='center'>베이비페이스에 오신 것을 환영합니다</Text>
      <LoginLogoImage src={`${babyface}/signup/signin_baby.png`} alt="로그인 로고 이미지" />
      <Flex column alignItems="strecth" style={{ width: '100%' }}>
        <Flex column alignItems="center" style={{ margin: '0.625rem auto 3.125rem' }}>
          <NaverLoginButton style={{ padding: '0 0 1.25rem' }} icon={true}/>
        </Flex>
        <Text size="12" textAlign="center" style={{ marginBottom: '0.5rem' }}>또는 이메일로 로그인하기</Text>
        <InputForm
          state={state}
          formData={SIGNIN_DATA}
          onChangeValue={onChangeValue}
          onValidate={onValidate}
          onSubmit={onSignin}
          size={3}
        >
          <Flex padding="0.313rem 0 1.25rem" justifyContent="flex-end">
            <TextLink link={PATH.FIND} size="12" color="brownGrey">
              아이디/비밀번호를 잊어버리셨나요?
            </TextLink>
          </Flex>
          <Button
            style={{ height: '2.595rem' }}
            onClick={onSignin}
            isLoading={isLoading}
            color={isValidateTrue ? 'orangePink' : 'pinkishGrey'}
          >
            {SUBMIT_BUTTON}
          </Button>
          <SignupButton
            style={{ height: '2.595rem', marginTop: '1.25rem' }}
            onClick={() => history.push(PATH.SIGNUP)}
            >
            {SIGNUP_BUTTON}
          </SignupButton>
        </InputForm>
      </Flex>
    </PageTemplate>
  );
};

export default React.memo(SigninTemplate);

const PAGE_TITLE = '로그인 | 회원가입';
const SUBMIT_BUTTON = '로그인';
const SIGNUP_BUTTON = '회원가입';
const SIGNIN_DATA = [
  {
    mainIconName: 'email',
    subIconName: null,
    placeholder: '예) babyface@babyface.com',
    type: 'email',
    name: 'email',
  },
  {
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '예) babyFace123@',
    type: 'password',
    name: 'password',
  },
];

const LoginLogoImage = styled.img`
  display: block;
  margin: 1.9rem auto;
  width: 9rem;
`;

const SignupButton = styled(Button)`
  border: ${(props) =>
    `1px solid ${props.theme.color.orangePink}`};
  border-radius: 0.375rem;
  background: ${(props) => props.theme.color.background};
  color: ${(props) => props.theme.color.orangePink};
`;